import type { QueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/types";

export async function invalidateMakeupQueries(
  queryClient: QueryClient,
): Promise<void> {
  await queryClient.invalidateQueries({
    queryKey: [QueryKeys.MakeupSessions],
    refetchType: "all",
  });
  await queryClient.invalidateQueries({
    queryKey: [QueryKeys.Attendance, "eligible-makeup-sessions"],
    refetchType: "all",
  });
  await queryClient.invalidateQueries({
    queryKey: [QueryKeys.WidgetData],
  });
}
